module.exports = __webpack_public_path__ + "static/media/image3.f239fa29.png";